import { render, staticRenderFns } from "./ReturnTop.vue?vue&type=template&id=86db38a2&scoped=true&"
import script from "./ReturnTop.vue?vue&type=script&lang=js&"
export * from "./ReturnTop.vue?vue&type=script&lang=js&"
import style0 from "./ReturnTop.vue?vue&type=style&index=0&id=86db38a2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86db38a2",
  null
  
)

export default component.exports